import { Component } from '@angular/core';
import { DepositsComponent } from './deposits.component';

@Component({
  selector: 'eid-deposits-desktop',
  templateUrl: './deposits.desktop.component.html',
  styleUrls: ['./deposits.desktop.component.scss']
})
export class DepositsDesktopComponent extends DepositsComponent {}
